type QuotationAreaIdentity = { areaName: string; floor?: number | string | null };

/** Area names repeat across floors, so both fields identify a quotation room. */
export const quotationAreaKey = ({ areaName, floor }: QuotationAreaIdentity): string =>
	JSON.stringify([areaName, Number(floor ?? 0)]);

export function withAreaNickname<T extends QuotationAreaIdentity>(
	areas: T[],
	target: QuotationAreaIdentity,
	nickname: string
): T[] {
	const targetKey = quotationAreaKey(target);
	return areas.map(area => (quotationAreaKey(area) === targetKey ? { ...area, nickname } : area));
}
